import { GRAY_COLORS } from '@/UIlibrary/globalTheme';
import { Typography } from '@/UIlibrary/Typography/Typography';
import { AlertCircle } from 'react-feather';

interface EmptySectionProps {
	t: (key: string) => string;
}

const EmptySection: React.FC<EmptySectionProps> = ({ t }) => (
	<div className="flex flex-col items-center justify-center py-8 text-center">
		<AlertCircle size={24} className="text-gray-400 mb-2" />
		<Typography size="sm" color={GRAY_COLORS.gray500}>
			{t('NoInformationMessage')}
		</Typography>
	</div>
);

export default EmptySection;
